import React from "react";
import { Link } from "react-router-dom";
import "./apps.css";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import { APPS } from "../../../Constants/Apps";
import { APPS_CONTENT } from "../../../Constants/AppsContent";
import { useTranslation } from "../../../Hooks/useTranslation";
import { useReveal } from "../../../Hooks/useReveal";
import { useDocumentTitle } from "../../../Hooks/useDocumentTitle";

const AppsList = () => {
  const { t, language } = useTranslation();
  useDocumentTitle(t.apps.pageTitle);
  useReveal();

  return (
    <>
      <Navbar />
      <main className="apps-list-page">
        <section className="app-hero apps-list-hero">
          <div className="app-hero-glow" aria-hidden="true" />
          <div className="container">
            <span className="eyebrow hero-anim" style={{ "--d": 0 }}>{t.apps.eyebrow}</span>
            <h1 className="hero-anim" style={{ "--d": 1 }}>{t.apps.title}</h1>
            <p className="apps-list-text hero-anim" style={{ "--d": 2 }}>{t.apps.text}</p>
          </div>
        </section>
        <section className="section app-section">
          <div className="container">
            <div className="row apps-grid">
              {APPS.map((app, index) => {
                const content = APPS_CONTENT[language][app.id];
              const stores = [app.storeLink && "App Store", app.playStoreLink && "Google Play"].filter(Boolean);
                return (
                  <div key={app.id} className="col-12 col-md-6 col-lg-4">
                    <Link
                      to={`/apps/${app.id}`}
                      className="app-tile"
                      data-reveal
                      style={{ "--d": index, "--app-accent": app.accent, "--app-accent-dark": app.accentDark }}
                    >
                      <div className="app-tile-top">
                        <img src={app.icon} alt="" className="app-tile-icon" />
                        <span className={`app-tile-status ${stores.length ? "is-live" : ""}`}>
                          {stores.length ? stores.join(" · ") : t.projects.comingSoon}
                        </span>
                      </div>
                      <h2>{app.name}</h2>
                      <p className="app-tile-tagline">{content.tagline}</p>
                      <p className="app-tile-text">{content.description}</p>
                      <span className="app-tile-cta">{t.apps.view} →</span>
                    </Link>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default AppsList;
